"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrderReviewModalController = void 0;
const react_1 = require("react");
const analytics_1 = require("../../services/analytics");
const orderToReview_1 = require("../../services/customer/orderToReview");
const orderReview_1 = require("../../services/orderReview");
const orderReview_2 = require("../../usecases/orderReview");
function useOrderReviewModalController({ customerId }) {
    var _a, _b, _c;
    const [openModal, setOpenModal] = (0, react_1.useState)(false);
    const [hasReviewed, setHasReviewed] = (0, react_1.useState)(false);
    const [{ orderToReview, orderReviewToast }, callOrderReviewNoticationUseCase] = (0, orderReview_2.useOrderReviewNotificationUseCase)({ customerId, hasReviewed });
    const [step, setStep] = (0, react_1.useState)(1);
    const tagService = (0, react_1.useMemo)(() => new orderReview_1.OrderReviewTagService(analytics_1.GoogleAnalyticsService), []);
    const storeName = ((_a = orderToReview === null || orderToReview === void 0 ? void 0 : orderToReview.reseller) === null || _a === void 0 ? void 0 : _a.name) || ((_c = (_b = orderToReview === null || orderToReview === void 0 ? void 0 : orderToReview.reseller) === null || _b === void 0 ? void 0 : _b.store) === null || _c === void 0 ? void 0 : _c.name);
    const skipOrderReviewFor24hours = () => {
        orderToReview_1.OrderReviewNotificationService.saveSkipDate();
        setHasReviewed(true);
        setOpenModal(false);
        orderReviewToast.close();
    };
    const handleToastClick = () => {
        setOpenModal(true);
    };
    const handleReview = () => {
        skipOrderReviewFor24hours();
    };
    const handleSkipReview = () => {
        skipOrderReviewFor24hours();
    };
    const handleModalClose = () => {
        tagService.closeClick(step);
        skipOrderReviewFor24hours();
    };
    const handleStepChange = (newStep) => {
        setStep(newStep);
    };
    (0, react_1.useEffect)(() => {
        callOrderReviewNoticationUseCase();
    }, [callOrderReviewNoticationUseCase]);
    return {
        hasReviewed,
        openModal,
        orderToReview,
        storeName,
        orderReviewToast,
        handleReview,
        handleSkipReview,
        handleModalClose,
        handleToastClick,
        handleStepChange,
    };
}
exports.useOrderReviewModalController = useOrderReviewModalController;
